import { useState, type FormEvent } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalDescription,
  ModalHeader,
  ModalOverlay,
  ModalPortal,
  ModalTitle,
} from '@klaro7/ui';

// ponytail: PIN nel bundle, serve solo a fermare i salvataggi per errore degli utenti non esperti.
// Protezione vera = controllo anche nell'API.
const PIN = '1712';

type Action = () => unknown;

/**
 * Chiede il PIN prima di eseguire un'azione che modifica qualcosa.
 *
 * Uso: `const { requirePin, pinDialog } = usePinGate();`, poi `onClick={() => requirePin(handleSave)}`
 * e `{pinDialog}` una volta nel JSX della pagina (come uno slot in Vue).
 */
export function usePinGate() {
  const [pending, setPending] = useState<Action | null>(null);
  const [value, setValue] = useState('');
  const [wrong, setWrong] = useState(false);

  function close() {
    setPending(null);
    setValue('');
    setWrong(false);
  }

  // () => action: senza, React chiamerebbe la funzione invece di salvarla nello state.
  function requirePin(action: Action) {
    setPending(() => action);
  }

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (value !== PIN) {
      setWrong(true);
      setValue('');
      return;
    }
    const action = pending;
    close();
    void action?.();
  }

  const pinDialog = (
    <Modal open={pending !== null} onOpenChange={(open) => !open && close()}>
      <ModalPortal>
        <ModalOverlay />
        <ModalContent className="max-w-sm">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>Inserisci la password</ModalTitle>
              <ModalDescription>Serve per confermare la modifica.</ModalDescription>
            </ModalHeader>
            <div className="mt-4">
              <Input
                type="password"
                inputMode="numeric"
                autoComplete="off"
                autoFocus
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setWrong(false);
                }}
                error={wrong ? 'Password errata' : undefined}
                aria-label="Password"
              />
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <Button type="button" variant="ghost" onClick={close}>
                Annulla
              </Button>
              <Button type="submit" disabled={value.length === 0}>
                Conferma
              </Button>
            </div>
          </form>
        </ModalContent>
      </ModalPortal>
    </Modal>
  );

  return { requirePin, pinDialog };
}
